export default __webpack_public_path__ + "static/media/ttd_manager_sdm.aa896233.jpg";